import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { initializeDevCycle, DevCycleClient } from '@devcycle/js-client-sdk';

export const FEATURE_FLAGS = {
  CHARGER_STATUS_ENABLE: 'charger-status-enable',
  WALLET_SETTINGS_ENABLE: 'wallet-settings-enable',
  SHOW_CONNECTOR_PAID_INFO: 'show-connector-paid-info',
  CONNECTOR_BUTTONS_ENABLE: 'connector-buttons-enable',
  EDIT_CHARGER_ENABLE: 'edit-charger-enable',
  SHOW_STATION_PROFILES: 'show-station-profiles',
  REPAIR_REPORT_ENABLE: 'repair-report-enable',
};

@Injectable({
  providedIn: 'root'
})
export class DevcycleService {
  private devCycleClient!: DevCycleClient;

  initializeDevCycle() {
    this.devCycleClient = initializeDevCycle(environment.devcycleClientSdkKey, { isAnonymous: true });
  }

  getFeatureFlag(flagKey: string, defaultValue?: boolean): boolean {
    if (!this.devCycleClient) return defaultValue ?? false;
    return this.devCycleClient.variableValue(flagKey, defaultValue);
  }

  whenNotFeatureFlag(flagKey: string, callback: () => void) {
    if (!this.getFeatureFlag(flagKey, false)) {
      callback();
    }
  }

  onVariableUpdated(variableName: string | '*', callback?: (key: string, value: boolean) => void) {
    if (!this.devCycleClient) return;
    this.devCycleClient.subscribe(`variableUpdated:${variableName}`, (key: string) => {
      callback(key, this.getFeatureFlag(key, false));
    });
  }
}
